import { prop } from 'ramda';
import { useEffect } from 'react';
import { useIsAdmin } from 'js/hooks/user';
import { usePrevious } from 'js/hooks/usePrevious';
import { useAuthSelector, useSocketSelector } from 'js/store/hooks';

import { useLoginBySSO } from './useLoginBySSO';

export const useSessionRestore = () => {
    const isAdmin = useIsAdmin();
    const loginBySSO = useLoginBySSO();
    const connected = useSocketSelector(prop('connected'));
    const prevConnected = usePrevious(connected, true);
    const wasSsoAttempted = useAuthSelector(prop(['wasSsoAttempted']));

    useEffect(() => {
        if (!connected || prevConnected || !wasSsoAttempted || isAdmin) {
            return;
        }

        loginBySSO();
    }, [
        isAdmin,
        connected,
        wasSsoAttempted,
        prevConnected,
        loginBySSO
    ]);
};
